module.exports = __webpack_public_path__ + "img/image (42).47360277.jpg";